import { gql } from "@apollo/client";

export const meUserFragment = gql`
    fragment MeUser on User {
        id
        firstName
        lastName
        hashtags
        interests {
            name
        }
    }
`;

export const ME_QUERY = gql`
    query Me {
        me {
            ...MeUser
        }
    }
    ${meUserFragment}
`;
